<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="100">
      <FormItem label="科室名称：" >{{editModel.departmentName}}</FormItem>
      <FormItem label="科室编号：">{{editModel.departmentCode}}</FormItem>
      <FormItem label="科室类型：">{{editModel.departmentType}}</FormItem>
      <FormItem label="所属机构：">
        <span>{{editModel.organName}}</span>
      </FormItem>
    </Form>
   <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props:["currentId"],
  data: function () {
    return {
      editModel: {
      
      },
    };
  },

  created: function () {
    this.initData(this.currentId);
  },

  methods: {
    initData(id) {
      this.$api.get(`department/getById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.editModel = rsp.data;
        }
      });
    },
    returnBack: function () {
      this.$emit("close")
    },
  },
};
</script>
<style scoped>
</style>